import { render, staticRenderFns } from "./fileActivities.vue?vue&type=template&id=2ce14227&scoped=true&"
import script from "./fileActivities.vue?vue&type=script&lang=js&"
export * from "./fileActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce14227",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce14227')) {
      api.createRecord('2ce14227', component.options)
    } else {
      api.reload('2ce14227', component.options)
    }
    module.hot.accept("./fileActivities.vue?vue&type=template&id=2ce14227&scoped=true&", function () {
      api.rerender('2ce14227', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/activities/components/fileActivities.vue"
export default component.exports